import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../../shared/error-boundary';

export default class SearchInput extends React.Component {
  static propTypes = {
    query: PropTypes.string,
  }

  static defaultProps = {
    query: '',
  }

  constructor(props, context) {
    super(props, context);

    this.state = { query: this.props.query };
  }

  handleQueryChange(e) {
    const query = e.target.value;

    this.setState({ query });
  }

  performSearch(e) {
    if (e && e.preventDefault) e.preventDefault();

    window.location = `/search/wires?query=${this.state.query}`;
  }

  render() {
    return (
      <ErrorBoundary>
        <form className="search-results-search-input --user-facing" onSubmit={e => this.performSearch(e)}>
          <section className="form-group">
            <label htmlFor="query">
              Search Livewire
              <input
                type="text"
                name="query"
                id="query"
                className="search-results-search-input-query"
                value={this.state.query}
                onChange={e => this.handleQueryChange(e)}
                placeholder="Search Livewire"
              />
            </label>
          </section>
        </form>
      </ErrorBoundary>
    );
  }
}
